import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
import { Icon } from '../Icon';
var OnetocShortcutSvg = function OnetocShortcutSvg() {
  return /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#605E5C",
    fillRule: "evenodd",
    d: "M6.5 10.204V2.25a.75.75 0 0 1 .75-.75h12.5a.75.75 0 0 1 .75.75v19.5a.75.75 0 0 1-.75.75H9.796q.142-.245.269-.5h9.685a.25.25 0 0 0 .25-.25V2.25a.25.25 0 0 0-.25-.25H7.25a.25.25 0 0 0-.25.25v8.266a9 9 0 0 0-.5-.312",
    clipRule: "evenodd",
    opacity: 0.64
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M7 10.516A8.99 8.99 0 0 1 11 18a8.96 8.96 0 0 1-.935 4h9.685a.25.25 0 0 0 .25-.25V2.25a.25.25 0 0 0-.25-.25H7.25a.25.25 0 0 0-.25.25z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9332BF",
    d: "M21.5 14h-1V9.5h1a.5.5 0 0 1 .5.5v3.5a.5.5 0 0 1-.5.5"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AE4BD5",
    d: "M21.5 8.5h-1V4h1a.5.5 0 0 1 .5.5V8a.5.5 0 0 1-.5.5"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7719AA",
    d: "M21.5 19.5h-1V15h1a.5.5 0 0 1 .5.5V19a.5.5 0 0 1-.5.5"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7719AA",
    fillRule: "evenodd",
    d: "M2 9v-.5a1 1 0 0 1 1-1h9a1 1 0 0 1 1 1v9a1 1 0 0 1-1 1h-1.014q.015-.248.014-.5a9 9 0 0 0-9-9",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F9F7F7",
    fillRule: "evenodd",
    d: "M10.383 14.718V10h-1.29l.01 2.472a9 9 0 0 1 1.28 2.246m-4.1-4.635L6.23 10h-.102z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M4.313 23.583q-1.793 0-3.053-1.245T0 19.295q0-1.27.647-2.288a4.36 4.36 0 0 1 1.725-1.57H0V14h5.39v5.39H3.954v-2.97a2.72 2.72 0 0 0-1.797.934 2.8 2.8 0 0 0-.719 1.917q0 1.201.839 2.038a2.78 2.78 0 0 0 2.037.837z"
  }));
};
export var OnetocShortcut = function OnetocShortcut(props) {
  return /*#__PURE__*/React.createElement(Icon, _extends({}, props, {
    component: OnetocShortcutSvg
  }));
};